import React from 'react';

function ReviewCard(props) {
    const getFirstLetter = (str) => {
        return str.charAt(0);
      };
    return (
        <div className='flex flex-col space-y-3'>
            <div className='flex flex-row space-x-2 items-center'>
                <span className='rounded-full grid p-1 bg-[#4CA9FF] h-[40px] w-[40px] text-white text-[13px]'><span className='my-auto'>{getFirstLetter(props.feedbackName ? props.feedbackName : 'Amonymous')}</span></span>
                <span className='text-[16px] font-[400]'>{!props.feedbackName || props.feedbackName == '' ? 'Anonymous' : props.name}</span>
            </div>
            <div className='text-[20px] font-[400] text-start'>{props.title? props.title : ''}</div>
            <div className='text-[#545454] text-[14px] text-start'>
                {props.feedbackValue}
            </div>
            <div><hr></hr></div>
        </div>
    );
}

export default ReviewCard;